<template>
  <button 
    :class="[$attrs.class, btn_class]"
    @click="handleClick"
    :disabled="is_disabled" >
    <clip-loader :loading="is_process" :size="loading_text.size" :color="loading_text.color" v-if="is_process"></clip-loader>
    <slot v-else></slot>
  </button>
</template>
<script>
	import {mapGetters} from 'vuex'
	export default{
		props:{
			disabled:{
				type: Boolean,
				default: false
			},
			data:{
				type: Object,
				default: () => {}
			},
			click:{
				type: Function
			},
			size:{
				type: String,
				default: 'md'
			},
			variant:{
				type: String,
				default: 'primary'
			},
			block:{
				type: Boolean,
				default: false
			},
			use_notif:{
				type: Boolean,
				default: false
			}
		},
		data(){
			return{
				is_process: false,
				is_disabled: false,
				loading_text:{
					color: "#222",
					size: "14px"
				}
			}
		},
		created(){
			this.is_disabled = this.disabled
		},
		computed:{
			...mapGetters(['getMerchant']),
			btn_class(){
				let return_data = 'g-btn'
				if(this.block){
					return_data += ' w-100 px-0'
				}
				if(this.variant == 'primary'){
					return_data += ' g-btn-primary'
					this.loading_text.color = '#fff'
				}if(this.variant == 'primary-ticket'){
					return_data += ' g-btn-primary-ticket'
					this.loading_text.color = '#fff'
				}else if(this.variant == 'primary-outline'){
					return_data += ' g-btn-primary-outline'
					this.loading_text.color = this.getMerchant.primary_color
				}else if(this.variant == 'danger-outline'){
					return_data += ' g-btn-danger-outline'
					this.loading_text.color = this.getMerchant.primary_color
				}else if(this.variant == 'secondary'){
					return_data += ' g-btn-secondary'
					this.loading_text.color = '#fff'
				}else if(this.variant == 'secondary-outline'){
					return_data += ' g-btn-secondary-outline'
					this.loading_text.color = this.getMerchant.button_color_1
				}else if(this.variant == 'light'){
					return_data += ' g-btn-light'
					this.loading_text.color = "#222"
				}else if(this.variant == 'light-outline'){
					return_data += ' g-btn-light-outline'
					this.loading_text.color = "#222"
				}else if(this.variant == 'dark'){
					return_data += ' g-btn-dark'
					this.loading_text.color = "#fff"
				}else if(this.variant == 'dark-outline'){
					return_data += ' g-btn-dark-outline'
					this.loading_text.color = "#231F20"
				}else if(this.variant == 'original'){
					return_data += ' g-btn-primary-ori'
					this.loading_text.color = "#fff"
				}else if(this.variant == 'original-outline'){
					return_data += ' g-btn-primary-ori-outile'
					this.loading_text.color = "#26B11D"
				}

				if(this.size == 'sm'){
					return_data += ' g-btn-sm'
					this.loading_text.size = '12px'
				}else if(this.size == 'md'){
					return_data += ' g-btn-md'
					this.loading_text.size = '14px'
				}else if(this.size == 'lg'){
					return_data += ' g-btn-lg'
				}else if(this.size == 'xl'){
					return_data += ' g-btn-xl'
				}

				return return_data
			}
		},
		watch:{
			disabled(newVal, oldVal){
				this.is_disabled = newVal
			},
		},
		methods:{
			handleClick(){
				this.is_disabled = true
				this.is_process = true
				this.click(this.data).then(response=>{
					if(this.use_notif){
						this.$notify({
						  title: 'Successfully',
						  type: 'success',
						  position: 'top left',
						  text: response
						});
					}
				}).catch(error=>{
					if(this.use_notif){
							this.$notify({
						  title: 'Error',
						  type: 'warn',
						  position: 'top left',
						  text: error
						});
					}
				}).finally(()=>{
					this.is_disabled = false
					this.is_process = false
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/stateButton.vue